module.exports = __webpack_public_path__ + "static/media/baldwin-logo.3da5fccc.jpg";